import { COUNTRY_CODE } from '@cemex-core/cmx-api';
import { frConfig } from './fr/fr';
import { ilConfig } from './il/il';
import { esConfig } from './es/es';
import { niConfig } from './ni/ni';
import { peConfig } from './pe/pe';
import { plConfig } from './pl/pl';
import { phConfig } from './ph/ph';
import { ukConfig } from './uk/uk';
import { czConfig } from './cz/cz';
import { aeConfig } from './ae/ae';
import { deConfig } from './de/de';
import { egConfig } from './eg/eg';
import { usConfig } from './us/us';
import { mxConfig } from './mx/mx';
import { lvConfig } from './lv/lv';
import { coConfig } from './co/co';
import { baConfig } from './ba/ba';
import { prConfig } from './pr/pr';
import { crConfig } from './cr/cr';
import { paConfig } from './pa/pa';
import { svConfig } from './sv/sv';
import { doConfig } from './do/do';
import { gtConfig } from './gt/gt';
import { hrConfig } from './hr/hr';

export const formConfig = {
  [COUNTRY_CODE.FRANCE]: frConfig,
  [COUNTRY_CODE.ISRAEL]: ilConfig,
  [COUNTRY_CODE.SPAIN]: esConfig,
  [COUNTRY_CODE.NICARAGUA]: niConfig,
  [COUNTRY_CODE.PERU]: peConfig,
  [COUNTRY_CODE.PHILIPPINES]: phConfig,
  [COUNTRY_CODE.POLAND]: plConfig,
  [COUNTRY_CODE.UNITED_KINGDOM]: ukConfig,
  [COUNTRY_CODE.CZECH_REPUBLIC]: czConfig,
  [COUNTRY_CODE.UNITED_ARAB_EMIRATES]: aeConfig,
  [COUNTRY_CODE.GERMANY]: deConfig,
  [COUNTRY_CODE.EGYPT]: egConfig,
  [COUNTRY_CODE.USA]: usConfig,
  [COUNTRY_CODE.MEXICO]: mxConfig,
  [COUNTRY_CODE.LATVIA]: lvConfig,
  [COUNTRY_CODE.COLOMBIA]: coConfig,
  [COUNTRY_CODE.BOSNIA_AND_HERZEGOVINA]: baConfig,
  [COUNTRY_CODE.PUERTO_RICO]: prConfig,
  [COUNTRY_CODE.COSTA_RICA]: crConfig,
  [COUNTRY_CODE.PANAMA]: paConfig,
  [COUNTRY_CODE.EL_SALVADOR]: svConfig,
  [COUNTRY_CODE.DOMINICAN_REPUBLIC]: doConfig,
  [COUNTRY_CODE.CROATIA]: hrConfig,
  [COUNTRY_CODE.GUATEMALA]: gtConfig,
};
